import { Deserializable } from '../protocols/deserializable';
import { VariableBenefitPaymentChangeSubmissionData } from './variable-benefit-payment-change-submission-data';

export class VariableBenefitPaymentChangeSubmission implements Deserializable {
  public accountId!: number;
  public estimatedAnnualTotalPaymentAmount!: number;
  public previous!: VariableBenefitPaymentChangeSubmissionData;
  public new!: VariableBenefitPaymentChangeSubmissionData;

  public onDeserialize(): void {
    const Deserialize = window.injector.Deserialize;
    if (this.new) {
      this.new = Deserialize.instanceOf(VariableBenefitPaymentChangeSubmissionData, this.new);
    }

    if (this.previous) {
      this.previous = Deserialize.instanceOf(VariableBenefitPaymentChangeSubmissionData, this.previous);
    }
  }
}
